<!-- <ngx-ui-loader *ngIf="expression"></ngx-ui-loader> -->
<!-- <ngx-loading-x [show]="show">

</ngx-loading-x> -->
<!-- <div *ngIf="show"><img src="assets/images/NXT_logo_gif.gif" alt=""
        srcset=""></div> -->


        

@if (show) {
  <div id="load_screen">
    <!-- <div class="loader">
    <div class="loader-content">
      <div class="spinner-border text-primary align-self-center loader-lg"></div>
    </div>
  </div> -->
  <div class="splash-screen">
    <img src="./assets/img/logo.png" alt="Relipay logo">
    <div class="spinner">
      <div class="bounce1"></div>
      <div class="bounce2"></div>
      <div class="bounce3"></div>
      <div class="bounce4"></div>
    </div>
  </div>
</div>
}
